import { TablePagination } from '@mui/material'
import { ROWS_PER_PAGE_OPTIONS } from './useTablePagination'

interface TablePaginationBarProps {
  count: number
  page: number
  rowsPerPage: number
  setPage: (page: number) => void
  setRowsPerPage: (rowsPerPage: number) => void
}

/**
 * Footer pagination bar for Job Search list tables (MWA-254 Defect 2). Render
 * directly below the scrollable table body, inside the bordered table container.
 * Defaults to 25 rows/page with 10/25/50 options. Hidden when there are fewer
 * rows than the smallest page size (nothing to page through).
 */
export default function TablePaginationBar({
  count,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
}: TablePaginationBarProps) {
  if (count <= ROWS_PER_PAGE_OPTIONS[0]) return null

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      onPageChange={(_, next) => setPage(next)}
      onRowsPerPageChange={(e) => {
        setRowsPerPage(parseInt(e.target.value, 10))
        setPage(0)
      }}
      sx={{ borderTop: 1, borderColor: 'divider' }}
    />
  )
}
